import React from "react";
import "./BrandMapInstructions.css";
const BrandMappingInstructions = (props) => {
  return (
    <div className="brand-mapping-instruction-container">
      <div className="brand_map_heading mb-10">Brand Mapping Instructions</div>
      <div className="row-height">
        <b>If Brand is new</b> to the company (never sold before/not found in
        PDF or Stella):
      </div>
      <div className="row-height first-arrow">
        <span className="right-arrow">&#8594;</span>
        Enter Brand name as you want it to appear on site, signs, or marketing
        materials.
      </div>
      <div className="row-height">
        <span className="right-arrow">&#8594;</span>
        Indicate that the Brand is new.
      </div>
      <div className="row-height">
        <span className="right-arrow">&#8594;</span>
        Enter Vendor/Brand URL on the Company Details page so Brand Admin can
        validate spelling/punctuation.
      </div>
      <div className="note mb-10">
        Note on URLs: If Vendor or Brand does not have a website, you can leave
        this blank. However, If URL field is left blank, Brand will be created
        as entered in the Brand Name field, so be mindful of capitalization,
        punctuation, etc.
      </div>
      <div className="row-height">
        <b className="mr-b-5"> If Brand already exists</b>(whether in your FOB
        or another FOB in the company):
      </div>
      <div className="row-height first-arrow">
        <span className="right-arrow">&#8594;</span>
        Indicate that the Brand already exists.
      </div>
      <div className="row-height">
        <span className="right-arrow">&#8594;</span>
        Enter the Brand name as displayed in PDF / Stella.
      </div>
      <div className="row-height">
        <span className="right-arrow">&#8594;</span>
        No Vendor/Brand URL needed.
      </div>
      <div className="note  mb-10">
        Note: If Brand is not entered as currently displayed in PDF/ Stella,
        there is a possibility of a duplicate Brand being created with a
        slightly different spelling, etc. based on how it was entered on this
        form.
      </div>
      <div className="note-new">
        <b>
          If more than one Brand applies to an individual DVN (a.k.a.
          Class-Level Mapping)
        </b>
        , then you should select all Brands that apply to the DVN in the Brand
        dropdown.
        <b className="ml-b-5 mr-b-5">
          By selecting more than one Brand in this dropdown, you are required to
          upload a Brand Mapping Template in the Document Center.
        </b>
        You will not be able to submit a vendor record without returning to the
        Document Center and adding a Brand Mapping template.
      </div>
      <div className="brand_map_heading mt-10">Freight Terms Instructions</div>
      <div>
        Overview: Vendors are required to pay 100% of freight costs. If you
        select a partial or zero cost option, then you are required to upload an
        explanation to the Document Center in order to submit this vendor record
        to Accounts Payable for DVN creation.
      </div>
      <div className="explanation_opt mb-10">Explanation of options:</div>
      <div className="row-height">
        <b> Option #1:</b> Vendor pays 100% of freight costs (FA100) - REQUIRED
      </div>
      <span className="right-arrow line-height">&#8594;</span>
      Vendor ships "collect". Division pays the freight invoice then offsets
      100% of that invoice back to the vendor. The offset will be a deduction
      from their next check.
      <div className="row-height ">
        <b> Option #2:</b> ONLY AN OPTION FOR FURNITURE AND MATTRESSES, JEWELRY,
        CONFECTIONS AND DIRECT TO STORE.
      </div>
      <div className="row-height">
        <span className="right-arrow line-height">&#8594;</span>
        Vendor pays all inbound freight - (PRPD)
      </div>
      <div className="row-height ">
        <b> Option #3:</b> Vendor pays partial freight (between 5% and 95%)
      </div>
      <div className="row-height-new">
        <span className="right-arrow  line-height">&#8594;</span>
        Vendor ships "collect". Division pays the freight invoice then offsets
        the selected percentage of each invoice back to the vendor. The offset
        will be a deduction from the vendor's check.
      </div>
      <div className="row-height ">
        <b> Option #4:</b> Vendor pays no freight costs (0%)
      </div>
      <div className="row-height">
        <span className="right-arrow line-height">&#8594;</span>
        Division pays 100% of freight costs - (NONE)
      </div>
      <div className="row-height">
        <span className="right-arrow line-height">&#8594;</span>
        Vendor ships "collect" – The vendor does not agree to offset part or all
        of the freight expenses
      </div>
    </div>
  );
};
export default BrandMappingInstructions;
